module.exports = __webpack_public_path__ + "static/media/gray_animal_birds.1245e33d.png";